import React, { useState } from "react";
import { format } from "date-fns";
import {
  FaCheckCircle,
  FaHourglassHalf,
  FaTimesCircle,
  FaBan,
  FaSpinner,
  FaTimes,
  FaTicketAlt,
  FaClock,
  FaUser,
  FaUserTie,
  FaStar,
  FaHardHat,
  FaTools,
  FaHistory,
  FaFilePdf
} from "react-icons/fa";
import styles from "./Card.module.css";
import { generateMtoReport } from "./utils/pdfGeneratorMto";

function Card({ ticket }) {
  const [showModal, setShowModal] = useState(false);

  if (!ticket) return null;

  const formatFecha = (fecha) => {
    try {
      return format(new Date(fecha), "dd/MM/yyyy HH:mm");
    } catch (e) {
      return fecha;
    }
  };

  const getEstadoInfo = (estadoId) => {
    switch (estadoId) {
      case 1:
        return { descripcion: "Creado", icon: <FaCheckCircle className={styles.iconCreated} />, className: styles.createdBadge };
      case 2:
        return { descripcion: "Asignado", icon: <FaSpinner className={styles.iconInProcess} />, className: styles.processBadge };
      case 3:
        return { descripcion: "Pendiente", icon: <FaHourglassHalf className={styles.iconPending} />, className: styles.pendingBadge };
      case 4:
        return { descripcion: "Resuelto", icon: <FaTimesCircle className={styles.iconClosed} />, className: styles.resolvedBadge };
      case 5:
        return { descripcion: "Cerrado", icon: <FaCheckCircle className={styles.iconResolved} />, className: styles.closedBadge };
      case 6:
        return { descripcion: "Cancelado", icon: <FaBan className={styles.iconCancelled} />, className: styles.cancelledBadge };
      default:
        return { descripcion: "Desconocido", icon: null, className: "" };
    }
  };

  const estado = getEstadoInfo(ticket.EstadoId);

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.ticketBadge}>
            <FaTicketAlt />
            <span>#{ticket.TicketId}</span>
          </div>
          <div className={styles.statusIcon}>
            {ticket.EstadoId === 4 || ticket.EstadoId === 5 ? (
              <FaFilePdf 
                color="#e31818" 
                size={22} 
                style={{ cursor: 'pointer', marginRight: '10px' }} 
                title="Descargar Reporte"
                onClick={(e) => { e.stopPropagation(); generateMtoReport(ticket); }} 
              />
            ) : null}
            {estado.icon}
          </div>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.infoRow}>
            <FaClock color="#94a3b8" />
            <span className={styles.label}>Última Act.:</span>
            <span className={styles.value}>{formatFecha(ticket.fecha)}</span>
          </div>

          <div className={styles.infoRow}>
            <FaUser color="#94a3b8" />
            <span className={styles.label}>Usuario:</span>
            <span className={styles.value}>{ticket.nombre || "N/A"}</span>
          </div>

          <div className={styles.infoRow}>
            <FaHardHat color="#f59e0b" />
            <span className={styles.label}>Técnico:</span>
            <span className={styles.value}>{ticket.nombreTecnico}</span>
          </div>

          <div className={styles.infoRow}>
            <FaTools color="#3b82f6" />
            <span className={styles.label}>Equipo:</span>
            <span className={styles.value}>{ticket.equipo} ({ticket.cod})</span>
          </div>

          <div className={styles.infoRow}>
            <FaStar color="#fbbf24" />
            <span className={styles.label}>Calificación:</span>
            <span className={styles.value}>{ticket.votacion ? `${ticket.votacion} / 5` : "N/A"}</span>
          </div>
        </div>

        <button
          className={styles.detalleBtn}
          onClick={() => setShowModal(true)}
        >
          Ver Historial Completo
        </button>
      </div>

      {/* ================= MODAL PRO MTO ================= */}
      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3><FaHistory style={{ marginRight: '12px' }} /> Trazabilidad del Ticket #{ticket.TicketId}</h3>
              <FaTimes
                className={styles.closeIcon}
                onClick={() => setShowModal(false)}
              />
            </div>

            <div className={styles.modalContent}>
              <div className={styles.modalInfoPanel}>
                <div className={styles.panelItem}>
                  <strong>Usuario:</strong> {ticket.nombre}
                </div>
                <div className={styles.panelItem}>
                  <strong>Equipo:</strong> {ticket.equipo}
                </div>
                <div className={styles.panelItem}>
                  <strong>ID/Sello:</strong> {ticket.cod}
                </div>
              </div>

              <div className={styles.timeline}>
                {ticket.fullHistorial
                  .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                  .map((item, index) => {
                    const itemEstado = getEstadoInfo(item.EstadoId);
                    return (
                      <div key={index} className={styles.detailCard}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                          <span style={{ fontSize: '0.75rem', fontWeight: '700', color: '#94a3b8' }}>
                            <FaClock style={{ marginRight: '6px' }} />
                            {formatFecha(item.fecha)}
                          </span>
                          <span style={{
                            padding: '4px 10px',
                            borderRadius: '6px',
                            fontSize: '0.7rem',
                            fontWeight: '800',
                            textTransform: 'uppercase',
                            background: 'rgba(241, 245, 249, 1)',
                            color: '#475569'
                          }}>
                            {itemEstado.descripcion}
                          </span>
                        </div>
                        <p style={{ margin: 0, lineHeight: '1.5', color: '#1e293b', fontSize: '0.9rem' }}>
                          {item.observacion || "Sin observación registrada."}
                        </p>

                        {/* 🔵 Mostrar observación de resolución si el estado es 4 */}
                        {item.EstadoId === 4 && item.resolucion?.observaciones_gen && (
                          <div style={{
                            marginTop: '12px',
                            padding: '10px',
                            backgroundColor: '#ecfdf5',
                            borderLeft: '4px solid #10b981',
                            borderRadius: '6px'
                          }}>
                            <strong style={{ color: '#065f46' }}>
                              Observación de Resuelto:
                            </strong>
                            <p style={{
                              marginTop: '6px',
                              marginBottom: 0,
                              fontSize: '0.85rem',
                              color: '#064e3b'
                            }}>
                              {item.resolucion.observaciones_gen}
                            </p>
                          </div>
                        )}
                        {item.nombre_tecnico && (
                          <div style={{ marginTop: '10px', fontSize: '0.8rem', color: '#64748b', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <FaUserTie size={12} /> <strong>Técnico:</strong> {item.nombre_tecnico}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Card;
